import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

// "Deep Sea Instrument" palette — a maritime identity for SNS (Oman Maritime Academy):
// abyss navy + sea teal + a warm brass accent, on chart-paper. See src/styles/app-theme.css
// for typography, chrome (app bar / drawer), motion and component polish that build on these.
export default new Vuetify({
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: '#0C3A5B',   // abyss navy
        secondary: '#0E8390', // sea teal
        accent: '#D69A34',    // brass
        anchor: '#0E8390',    // links -> teal
        info: '#2E7DA6',      // signal blue
        success: '#2E8B6F',   // sea green
        warning: '#D69A34',   // brass
        error: '#C0453B',     // signal red
      },
    },
  },
});
